import React, {Component} from 'react'
import {Link} from '../../routes'
import {getArticlePublishedDate} from '../../utils/date'
import {ArrowIcon} from '../../icons/ArrowIcon'
import {getCategorySlugParamFriendly} from '../../routes/paths'

class ArticleHeader extends Component {
  getByLine () {
    const {article} = this.props
    return article.authorAlternateName || article.authors.map(author => author.name).join(', ')
  }

  render () {
    const {article} = this.props
    return (
      <div className='ArticleHeader'>
        {/* <div className='ArticleHeader__details'>
          <span className='ArticleHeader__details__category'>
            <Link route={'category'} params={{id: getCategorySlugParamFriendly(article.parentCategory)}}>
              <a>{article.parentCategory.name}</a>
            </Link>
          </span>
          <span className='ArticleHeader__details__divider'>
            <ArrowIcon />
          </span>
          <span className='ArticleHeader__details__category'>
            <Link route={'subcategory'}
              params={{
                parentCategory: getCategorySlugParamFriendly(article.parentCategory),
                id: getCategorySlugParamFriendly(article.category)
              }}>
              <a>{article.category.name}</a>
            </Link>
          </span>
        </div> */}
        <div className='ArticleHeader__heading'>
          <h1>{article.heading}</h1>
        </div>
        <div>
          <span className='ArticleHeader__author'>
            by <span>{this.getByLine()}</span>
            {/* {', '} */}
          </span>
          {/* <span className='ArticleHeader__date'>{getArticlePublishedDate(article.publishedDate)}</span> */}
        </div>

        { /* TODO change this once content api fixes its urls */
          // article.series &&
          // <div className='ArticleHeader__author'>
          //   Part of our{' '}
          //   <Link route='series' params={{id: article.series.path.slice(1).replace(/\//g, '_')}}>
          //     <a className='ArticleHeader__series'>{article.series.name}</a>
          //   </Link>
          //   {' '}
          //   series
          // </div>
        }
      </div>
    )
  }
}

ArticleHeader.defaultProps = {}

export default ArticleHeader



// WEBPACK FOOTER //
// ./client/components/ArticleHeader/ArticleHeader.js